export default __webpack_public_path__ + "static/media/test_result_ok.0838d0f9.svg";